import { i18n } from 'src/i18n';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'level1',
    label: 'level1',
    schema: schemas.string(
      i18n('entities.location.fields.level1'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'level2',
    label: 'level2',
    schema: schemas.string(
      i18n('entities.location.fields.level2'),
      {},
    ),
  },
  {
    name: 'level3',
    label: 'level3',
    schema: schemas.string(
      i18n('entities.location.fields.level3'),
      {},
    ),
  },
  {
    name: 'level4',
    label: 'level4',
    schema: schemas.string(
      i18n('entities.location.fields.level4'),
      {},
    ),
  },
  {
    name: 'level5',
    label: 'level5',
    schema: schemas.string(
      i18n('entities.location.fields.level5'),
      {},
    ),
  },
];
